export const getWhatsappLink = (phone: string, text?: string) => {
  const formattedPhone = phone.replace(/\D+/g, '');
  if (!text) {
    return `https://wa.me/55${formattedPhone}`;
  }
  const encodedText = encodeURI(text);
  return `https://wa.me/55${formattedPhone}?text=${encodedText}`;
};
